import React, { useEffect, useMemo, useRef } from "react";

export default function Html({ config }) {
  const DynamicHtmlRenderer = ({ htmlString }) => {
    const containerRef = useRef(null);

    useEffect(() => {
      if (document.getElementById(config.id)) return;

      containerRef.current.setAttribute('id', config.id);

      const container = containerRef.current;
      if (!container) return;

      container.innerHTML = "";

      const template = document.createElement("template");
      template.innerHTML = htmlString.replaceAll('__SCRIPT__END__', '</script>');

      const externalScripts = [];
      const inlineScripts = [];

      const nodes = Array.from(template.content.childNodes);

      nodes.forEach((node) => {
        if (node.nodeName === "SCRIPT") {
          const scriptEl = node;
          const src = scriptEl.getAttribute("src");

          if (src) {
            externalScripts.push(scriptEl);
          } else {
            inlineScripts.push(scriptEl);
          }
        } else {
          container.appendChild(node.cloneNode(true));
        }
      });

      const loadScript = (script) =>
        new Promise((resolve, reject) => {
          const newScript = document.createElement("script");

          // Copia atributos do script original
          for (let attr of script.attributes) {
            newScript.setAttribute(attr.name, attr.value);
          }

          newScript.onload = resolve;
          newScript.onerror = reject;

          container.appendChild(newScript);
        });

      // 1. Carrega todos os scripts externos primeiro
      Promise.all(externalScripts.map(loadScript))
        .then(() => {
          // 2. Depois executa scripts inline
          inlineScripts.forEach((script) => {
            const newScript = document.createElement("script");
            newScript.textContent = script.textContent;
            container.appendChild(newScript);
          });
        })
        .catch((err) => {
          console.error("Erro ao carregar scripts externos:", err);
        });
    }, [htmlString]);

    return <div ref={containerRef} />;
  };

  return useMemo(
    () => (
      <div className="html-section" style={config.style || {}}>
        <DynamicHtmlRenderer htmlString={config.code} />
      </div>
    ),
    [config?.code]
  );
}
